export const ChannelEnum = [
  'FAM',
  'TEXAS_RED'
];